import { FC } from "react";
import { BookingSummaryProductBreakdown } from "../types";
import { parseNum } from "../utils/helpers";

interface ProductBreakdownProps {
    productBreakDown: BookingSummaryProductBreakdown
    productName: string
    visible: boolean
    mobile?: boolean
    open?: boolean
}

export const ProductBreakDown: FC<ProductBreakdownProps> = ({ productBreakDown, visible, productName, mobile, open }) => {

    return visible ? (
        <details className="mb-7 w-100 pe-n" open={open} aria-hidden tabIndex={-1}>
            <summary className="df aic jcsb mb-0 w-100" aria-hidden tabIndex={-1}>
                <p className={`text ${mobile ? 's18-600 white' : 's21-600'} w-100 mr-0 df aic jcsb`}>
                    <span>{`${productBreakDown.qty}x ${productBreakDown.items.length === 1 ? productBreakDown.items[0].name : productName}`}</span>
                    {   productBreakDown.items.length !== 1 ?

                        <span className={`text right ${mobile ? '18-600 white' : ''}`}>
                            {parseNum('EUR', productBreakDown.price)}
                        </span>

                        :

                        <span className={`text right ${mobile ? '18-600 white' : ''}`} aria-hidden>
                            {   productBreakDown.items[0].discounts.length > 0 &&
                                <span className="text softer strikethrough mr-4 18-600">
                                    {parseNum('EUR', productBreakDown.items[0].originalPrice * productBreakDown.items[0].qty)}
                                </span>
                            }
                            {parseNum('EUR', productBreakDown.items[0].price * productBreakDown.items[0].qty)}
                        </span>
                    }
                </p>
            </summary>
            {(productBreakDown.items.length > 1) && (
                productBreakDown.items.map((item, index) => {

                    return (
                        <p className={`df aic jcsb mt-3`} key={index}>
                            <span className={`text soft ${mobile ? 'white s16-400' : 's16-500'}`}>{`${item.qty}x ${item.name}`}</span>

                            <span className={`text ${mobile ? 'white s16-400' : 's16-500'}`} aria-hidden>
                                {   item.discounts.length > 0 &&
                                    <span className="text softer strikethrough mr-4 s16-500">
                                        {parseNum('EUR', item.originalPrice * item.qty)}
                                    </span>
                                }
                                {parseNum('EUR', item.price * item.qty)}
                            </span>
                        </p>
                    )
                })
            )}
        </details>
    ) : null
}